import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Input } from 'antd';

import defaultStyles from './style.less';

//https://reactjs.org/docs/hooks-reference.html#useref
//https://stackoverflow.com/questions/56453931/how-to-set-focus-to-an-antd-input-password-component
//https://reactjs.org/docs/hooks-effect.html

class InputAnswer extends React.Component {

  constructor (props) {
    console.log('constructor');
    super(props);
    this.onLocalChange = this.onLocalChange.bind(this);
  }

  onLocalChange(e) {
    const [index, ...options] = decodeURI(this.props.href.slice(1)).split('|').filter(s => !!s);
    const correctValue = options.filter(o => o.includes('*'))[0].replace(/\*/g, '').toLowerCase();
    this.props.onChange({ index, value: e.nativeEvent.target.value, correct: e.nativeEvent.target.value.toLowerCase() == correctValue });
  };

  render() {
    const { href,
            onChange,
            answer,
            disabled,
            mutating,
            inputStyle, //inline style for width
            styles = {
               correctAnswer: defaultStyles.correctAnswer,
               incorrectAnswer: defaultStyles.incorrectAnswer,
            }
          } = this.props;

    const [index, ...options] = decodeURI(href.slice(1)).split('|').filter(s => !!s);

    const answerElement = answer && answer.answerElements && answer.answerElements.find(ae => ae.index == index);
    const answervalue = answerElement && answerElement.value;

    const correctValue = options.filter(o => o.includes('*'))[0].replace(/\*/g, '').toLowerCase();
    const placeholder = options.filter(o => !o.includes('*'))[0] || 'Fill in the blanks';
    const isCorrect = (answervalue && answervalue.toLowerCase()) == correctValue;
    const selectClass = disabled ? (isCorrect ? styles.correctAnswer : styles.incorrectAnswer) : '';

    return (
      <Input
        id={href}
        style={inputStyle}
        className={selectClass}
        disabled={disabled || mutating}
        onChange={this.onLocalChange}
        placeholder={placeholder}
        value={answervalue}
      />
    );
  }
}

export default InputAnswer;
